module.exports = __webpack_public_path__ + "images/img-3YwrMe5.jpg";


//////////////////
// WEBPACK FOOTER
// ./frontend/cabinets/apps/rocket/assets/img/dashboard/year-results/ru/quids.jpg
// module id = 2008
// module chunks = 0